/* esint-enable */
import elementUi from './element-ui';
import vueSwiper from './vue-swiper';
import vant from './vant';
import crmCore from './crm-core';
// import 'crm-core';
import 'es6-promise-always';

export default {
  install: (Vue) => {
    Vue.use(elementUi);
    Vue.use(vueSwiper);
    Vue.use(vant);
    Vue.use(crmCore);
  }
}
/* esint-enable */
